export const STYLE_FILTERS = [
  { id: 'clean-girl', label: 'Clean Girl', zh: '极简日常' },
  { id: 'soft-romance', label: 'Soft Romance', zh: '软浪漫' },
  { id: 'quiet-luxury', label: 'Quiet Luxury', zh: '低调奢华' },
  { id: 'chrome-aura', label: 'Chrome & Aura', zh: '未来感镜面' },
  { id: 'dark-muse', label: 'Dark Muse', zh: '暗黑个性' },
  { id: 'playful-y2k', label: 'Playful Y2K', zh: '千禧趣味' },
];
export const SHAPE_FILTERS = [
  { id: 'almond', label: '杏仁形', aliases: ['almond', '杏仁', '杏仁形', '杏仁型'] },
  { id: 'oval', label: '椭圆形', aliases: ['oval', '椭圆', '椭圆形', '椭圆型'] },
  { id: 'square', label: '方形', aliases: ['square', '方形', '方型'] },
  { id: 'squoval', label: '方圆形', aliases: ['squoval', '方圆', '方圆形', '方圆型'] },
  { id: 'coffin', label: '芭蕾形', aliases: ['coffin', 'ballerina', '芭蕾', '芭蕾形', '棺材形'] },
  { id: 'stiletto', label: '尖头形', aliases: ['stiletto', '尖锥', '尖锥形', '尖头', '尖头形'] },
  { id: 'round', label: '圆形', aliases: ['round', '圆形', '圆型', '短圆', '短圆形'] },
];
export const LENGTH_FILTERS = [
  { id: 'short', label: '短款', aliases: ['short', '短', '短款'] },
  { id: 'medium', label: '中长款', aliases: ['medium', '中长', '中长款', '中等', '中款'] },
  { id: 'long', label: '长款', aliases: ['long', '长', '长款'] },
  { id: 'extra-long', label: '超长款', aliases: ['extra-long', 'extra long', '超长', '超长款'] },
];
export const CRAFT_TIERS = [
  { id: 'classic-solid', price: '$9.99', title: 'Classic Solid · 经典纯色款', text: '基础纯色，简洁耐看，不含图案、装饰或额外工艺。' },
  { id: 'simple-art', price: '$14.99', title: 'Simple Art · 简约设计款', text: '基础图形搭配少量简约配饰，整体装饰轻盈。' },
  { id: 'detailed-art', price: '$24.99', title: 'Detailed Art · 精致设计款', text: '复杂图形、细节手绘及较丰富的配饰与工艺组合。' },
  { id: 'couture-custom', price: '$49.99 起', title: 'Couture Custom · 高定艺术定制款', text: '超复杂图形、立体装饰或原创定制，需先确认参考图。' },
];
export const metadataKey = value => String(value ?? '').trim().toLowerCase().replace(/[\s_&/]+/g, '-');
export function metadataValues(value) {
  if (Array.isArray(value)) return value.flatMap(metadataValues);
  if (value && typeof value === 'object') return [value.id, value.key, value.slug, value.name, value.nameZh].flatMap(metadataValues);
  if (typeof value !== 'string') return [];
  return value.split(/[,，|、/]+/).map(item => item.trim()).filter(Boolean);
}
export function productMetadata(product, keys, fallback = []) {
  const metadata = product?.metadata || product?.meta || {};
  const attributes = product?.attributes || product?.variantAttributes || {};
  const values = keys.flatMap(key => [product?.[key], metadata?.[key], attributes?.[key]]).flatMap(metadataValues);
  return values.length ? values : fallback.flatMap(metadataValues);
}
export function hasMetadata(product, keys, aliases, fallback = []) {
  const values = new Set(productMetadata(product, keys, fallback).map(metadataKey));
  return aliases.some(alias => values.has(metadataKey(alias)));
}
export function productStyles(product) {
  const values = productMetadata(product, ['style', 'styles', 'styleId', 'style_id', 'styleTags', 'style_tags', 'tags'], product?.mood ? [product.mood] : []);
  const keys = new Set(values.map(metadataKey));
  return catalogStyleFilters([product]).filter(item => [item.id, item.label, item.zh].some(value => keys.has(metadataKey(value))));
}
export function catalogStyleFilters(products = []) {
  const options = [...STYLE_FILTERS];
  const known = new Set(options.flatMap(item => [item.id, item.label, item.zh].map(metadataKey)));
  for (const product of products) {
    for (const value of productMetadata(product, ['styleTags', 'style_tags', 'styles'])) {
      const key = metadataKey(value);
      if (!key || known.has(key) || value.length > 50) continue;
      known.add(key);
      options.push({ id: `catalog:${value}`, label: value, zh: value });
    }
  }
  return options;
}
export function craftTierId(value) {
  const key = metadataKey(value);
  return CRAFT_TIERS.find(item => [item.id, item.title.split(' · ')[1]].map(metadataKey).includes(key))?.id || '';
}
export function hasDesignSeed(product) {
  const nails = product?.design?.nails;
  return Array.isArray(nails) && nails.length === 10 && nails.every(nail => nail && typeof nail === 'object' && !Array.isArray(nail));
}
export function publicMediaUrl(value, origin = globalThis.location?.origin || 'http://localhost') {
  if (typeof value !== 'string' || !value.trim()) return '';
  try { const url = new URL(value, origin); return ['http:', 'https:'].includes(url.protocol) ? url.href : ''; } catch { return ''; }
}
export function productMedia(product) {
  const source = Array.isArray(product.media) ? product.media : [];
  const main = publicMediaUrl(product.imageUrl);
  const media = main ? [{ kind: 'image', url: main, alt: product.name }] : [];
  const seen = new Set(main ? [main] : []);
  for (const item of source) {
    const url = publicMediaUrl(item?.url);
    if (!url || seen.has(url) || !['image', 'video'].includes(item.kind)) continue;
    media.push({ ...item, url, posterUrl: publicMediaUrl(item.posterUrl) });
    seen.add(url);
  }
  return media;
}
